import { EventEmitter, Injectable, Output } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';


/**
 * Obbliga l'implementazione del metodo ai componenti che devono usare questo Guard
 */
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})

export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(private modalService: BsModalService) { }

  /**
   * Questo metodo viene chiamato quando l'utente sta lasciando la pagina.
   * Chiede al componente se può lasciare la pagina o ci sono cose da salvare.
   * In caso affermativo mostra il popup di conferma.
   * @param component Componente che deve controllare se ci sono cose da salvare
   * @returns true nel caso non ci sono cose da salvare o se l'utente decide di scartare le modifiche
   */
  canDeactivate(component: CanComponentDeactivate, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (component.canDeactivate() || nextState.url == "/login") {
      return true;
    }

    const subject = new Subject<boolean>();
    let confermaModalRef = this.modalService.show(ConfirmModalComponent, { initialState: { message: "Proseguendo si perderanno le modifiche non salvate. Continuare comunque?" } });
    confermaModalRef.onHide.subscribe(() => {
      subject.next(confermaModalRef.content.result);
    });

    return subject.asObservable();
  }

}
